module.exports = __webpack_public_path__ + "img/ktv-party_zh.d0208a5a.jpg";